// @flow
import apiRequest from '../../stores/ApiService';
import apiConfig from '../../config';
import type { ApprovalStatus } from '../../api/types/Approvals';

type UpdateApprovalStatusData = {
  baseApiUrl: string,
  status: ApprovalStatus,
  packId: string,
  projectId: string,
  reason: string,
};

type GetApprovalsOptions = {
  baseApiUrl: string,
  status: ApprovalStatus,
  fromItem: number,
};

const getApprovals = ({ baseApiUrl, status, fromItem = 0 }: GetApprovalsOptions) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/${apiConfig.urls.approvalsConfiguration}?status=${status}&from=${fromItem}&size=6`,
  }).then((res) => {
    if (!res.ok) {
      return Promise.reject({ isUnauthorized: res.status === 403 });
    }

    return res.json();
  });

const getApprovalsCount = (baseApiUrl: string, status: ApprovalStatus) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/${apiConfig.urls.approvalsCountConfiguration}?status=${status}`,
  })
    .then((res) => res.json())
    .then((res) => res.total);

const updateApprovalStatus = ({ baseApiUrl, status, packId, projectId, reason }: UpdateApprovalStatusData) =>
  apiRequest({
    method: 'POST',
    url: `${baseApiUrl}/${apiConfig.urls.approvalsConfiguration}`,
    body: JSON.stringify({
      status,
      packId,
      projectId,
      reason,
    }),
  });

export default {
  getApprovals,
  getApprovalsCount,
  updateApprovalStatus,
};
